import React from "react";
import Banners from "../../components/HeroSlider/Banners";
import Alerts from "../../components/Alerts/Alerts";
import AllNotifications from "../../components/AllNotifications/AllNotifications";
import Aabout from "../../components/AboutAndVissionMission/AboutAndVissionMission";
import Accreditations from "../../components/Accreditations/Accreditations";
import OurPrograms from "../../components/OurPrograms/OurPrograms";
import StudentsLife from "../../components/studentsLife/studentsLife";
import Campus from "../../components/Campus/Campus";

const Home = () => {
  return (
    <>
      {/* Banners */}
      <Banners />
      {/* Alerts */}
      <Alerts />
      {/* AllNotifications */}
      <AllNotifications />
      {/* About */}
      <Aabout />
      {/* Accreditations */}
      <Accreditations />
      {/* OurPrograms */}
      <OurPrograms />
      {/* StudentsLife */}
      <StudentsLife />
      {/* Campus */}
      <Campus />

      {/* <div className="">
        <h1>Hello Index</h1>
      </div> */}
    </>
  );
};

export default Home;
